import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

let formFeedbackComponentNextId: number = 0;

@Component({
  selector: 'app-form-feedback',
  template: `
<div [id]="elementId" *ngIf="FormSuccess != null" aria-live="assertive" aria-relevant="additions removals">
  <div *ngIf="FormSuccess === true" class='bg-success text-white p-2 text-center'>
    <fa name="check-circle"></fa> <small>{{ FormSuccessText }}</small>
  </div>
  <div *ngIf="FormSuccess === false" class='bg-danger text-white p-2 text-center'>
    <fa name="exclamation-circle"></fa> <small>{{ FormFailText }}</small>
  </div>
</div>
`
})
export class FormFeedbackComponent implements OnChanges {
  @Input() FormSuccess: boolean | null = null;
  @Input() FormSuccessText: string = '';
  @Input() FormFailText: string = '';

  private readonly elementId: string;

  constructor() {
    this.elementId = `form-feedback-${++formFeedbackComponentNextId}`;
  }

  private scrollIntoViewIfNot(): void {
    const elementId = this.elementId;

    const timeoutID = setTimeout(() => {
      clearTimeout(timeoutID);

      let elSelf = document.getElementById(elementId);
      if (elSelf) {
        const rect = elSelf.getBoundingClientRect();
        if (rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
          /* element is already visible in viewport */
        } else {
          elSelf.scrollIntoView({ behavior: 'smooth' });
        }
        elSelf = null;
      }
    }, 0 /* as soon as possible */);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('FormFailText' in changes || 'FormSuccessText' in changes) {
      this.scrollIntoViewIfNot();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/global/formfeedback.component.ts